<div id="c_sitems_related_requests_heading">{{ 'SItemRelatedRequests.itemRelatedRequestsHeader' | translate }}</div>

<div *ngFor="let request of relatedItemRequest" id="c_sitems_related_requests">
    <div class="row">
        <div class="col-lg-5 col-xl-5 col-5">
            <img *ngIf="request.requestType === '1000'" src="img/incident.jpg" width=18 height=18 data-toggle="tooltip"
                data-placement="right" title="{{ 'RequestsList.incident' | translate }}" />
            <img *ngIf="request.requestType === '7000'" src="img/request.jpg" width=18 height=18 data-toggle="tooltip"
                data-placement="right" title="{{ 'RequestsList.servicerequest' | translate }}" />
            <img *ngIf="request.requestType === '3000'" src="img/change.jpg" width=18 height=18 data-toggle="tooltip"
                data-placement="right" title="{{ 'RequestsList.changerequest' | translate }}" />
            <img *ngIf="request.requestType === '2000'" src="img/problem.jpg" width=18 height=18 data-toggle="tooltip"
                data-placement="right" title="{{ 'RequestsList.problem' | translate }}" />
             <span id="c_sitem_related_requests_number" (click)="showRequestPage(request.requestNumber)"> {{ request.requestNumber }} </span>
        </div>
        <div class="col-lg-7 col-xl-7 col-7" id="c_sitem_related_requests_status">
            <span id="status_label">{{ 'SItemRelatedRequests.itemRelatedRequestsStatus' | translate }}: </span>
            <span><em> {{ request.status }}</em></span>
        </div>

    </div>
    <div class="row"  style="margin-top: 5px;color: #787878;" *ngIf="showSubject && request.subject !== null && request.subject.trim().length > 0 ">
        <div *ngIf="request.subject.length < 120; else elseBlock"  class="col-12 col-lg-12 col-xl-12">  
            {{ request.subject }}
        </div>
        <ng-template #elseBlock >
            <div  class="col-12 col-lg-12 col-xl-12" data-placement="left">{{ request.subject.slice(0,119)+'...' }}  </div>
        </ng-template>
    </div>
</div>

<div *ngIf="itemRelatedRequestCount === 0" class="text-center">
    {{ 'DataTableList.noRecords' | translate }} 
</div>
